export interface DiscountApplication {
  id: string;
  application_id: string;
  user_id: string;
  discount_type: '100%' | '50%';
  discount_reason_code: number;
  discount_reason_text: string;
  student_name: string;
  birthdate?: string;
  guardian_name?: string;
  address?: string;
  guardian_phone?: string;
  contact_phone?: string;
  bank_name?: string;
  account_number?: string;
  account_holder?: string;
  privacy_consent: boolean;
  user_confirmation: boolean;
  attachments: AttachmentFile[];
  status: 'submitted' | 'reviewed';
  reviewed_at?: string;
  reviewed_by?: string;
  admin_note?: string;
  created_at: string;
  updated_at: string;
}

export interface AttachmentFile {
  name: string;
  url: string;
  size: number;
}

export interface DiscountWithApplication extends DiscountApplication {
  application?: {
    id: string;
    application_number: string;
    status: string;
    payment_status: string;
    payment_amount: number;
    class_id: string;
  };
  class_info?: {
    id: string;
    class_name: string;
    program_id: string;
  };
  program_info?: {
    id: string;
    courseName: string;
  };
  user_info?: {
    name: string;
    phone: string;
    email: string;
    address: string;
    address_detail: string;
    birthdate: string;
  };
}

// 감면 사유 목록
export const DISCOUNT_REASONS = {
  '100%': [
    { code: 1, text: '국민기초생활 수급자' },
    { code: 2, text: '보호대상자, 그 유족 또는 가족' },
    { code: 3, text: '국민기초생활보장법에 따른 차상위계층' },
    { code: 4, text: '사회복지시설 거주자' },
    { code: 5, text: '한부모가족 세대원 및 조손가족의 세대원' },
  ],
  '50%': [
    { code: 6, text: '장애인복지법에 따른 장애인' },
    { code: 7, text: '두 자녀 이상 가정' },
    { code: 8, text: '다문화가족' },
    { code: 9, text: '청소년, 청년동아리, 청소년단체' },
    { code: 10, text: '북한 이탈주민가족 자녀' },
  ],
} as const;

export function getDiscountReasonText(code: number): string {
  const allReasons = [...DISCOUNT_REASONS['100%'], ...DISCOUNT_REASONS['50%']];
  return allReasons.find(r => r.code === code)?.text || '알 수 없음';
}

export function getDiscountType(code: number): '100%' | '50%' {
  return code <= 5 ? '100%' : '50%';
}
